/* layla-ar-wishlist.js - Wishlist page (Flits), both languages. Arabic: product names, colours, variant lists, header label, title, three-decimal prices. Both: price centred between the variant select and the quantity box; every column header sits on the same edge as its values (right in Arabic, left in English); Arabic row gap on the left = gap on the right. */
(function () {

  var WL = {};
  function wlLoad(handle) {
    if (WL[handle]) { return WL[handle]; }
    var get = function (u) { return fetch(u, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); };
    WL[handle] = Promise.all([get('/products/' + handle + '.js'), get('/ar/products/' + handle + '.js')]).then(function (res) {
      var en = res[0], ar = res[1], map = {};
      if (!en || !ar) { return map; }
      map[en.title] = ar.title;
      en.variants.forEach(function (v, i) {
        var a = ar.variants[i];
        if (!a) { return; }
        map[v.title] = a.title;
        if (v.public_title && a.public_title) { map[v.public_title] = a.public_title; }
        map[v.title + ' (Sold out)'] = a.title + ' (نفدت الكمية)';
      });
      (en.options || []).forEach(function (o, oi) {
        var eo = en.variants.map(function (v) { return v['option' + (oi + 1)]; });
        var ao = ar.variants.map(function (v) { return v['option' + (oi + 1)]; });
        eo.forEach(function (val, k) { if (val && ao[k]) { map[val] = ao[k]; } });
      });
      return map;
    });
    return WL[handle];
  }
  function wlSwap(el, map) {
    var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null), n, list = [];
    while ((n = w.nextNode())) { list.push(n); }
    list.forEach(function (node) {
      var t = node.nodeValue.trim();
      if (!t) { return; }
      if (map[t]) { node.nodeValue = node.nodeValue.replace(t, map[t]); return; }
      if (t.indexOf(' / ') > -1) {
        var parts = t.split(' / ').map(function (p) { return map[p] || p; });
        node.nodeValue = node.nodeValue.replace(t, parts.join(' / '));
      }
    });
  }
  var RTL = document.documentElement.getAttribute('dir') === 'rtl';
  function fixWishlist() {
    if (RTL) { fixArabic(); }
    layoutSoon();
  }
  function fixArabic() {
    var OLD = 'تحقق الأمنيات', NEW = 'أمنياتك تتحقق';
    var tw = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null), tn;
    while ((tn = tw.nextNode())) {
      if (tn.nodeValue.trim() === OLD) { tn.nodeValue = tn.nodeValue.replace(OLD, NEW); }
    }
    Array.prototype.forEach.call(document.querySelectorAll('.flits_wishlist_page_table_header_cell_variant'), function (h) {
      var t = h.textContent.trim();
      if (t && t !== 'المقاس واللون') { h.textContent = 'المقاس واللون'; }
    });
    Array.prototype.forEach.call(document.querySelectorAll('.flits_wishlist_page_table_row, .flits_wishlist_page_grid_item'), function (row) {
      var a = row.querySelector('a[href*="/products/"]');
      var m = a && a.getAttribute('href').match(/\/products\/([^/?#]+)/);
      if (!m) { return; }
      var handle = m[1];
      wlLoad(handle).then(function (map) {
        Array.prototype.forEach.call(row.querySelectorAll('.flits_wishlist_page_product_name, .flits_wishlist_page_product_variant, .flits_wishlist_page_variant_select option, .flits_wishlist_page_variant_static, [class*="product_title"]'), function (el) {
          wlSwap(el, map);
        });
        Array.prototype.forEach.call(row.querySelectorAll('img'), function (img) {
          if (map[img.alt]) { img.alt = map[img.alt]; }
        });
      });
    });
    Array.prototype.forEach.call(document.querySelectorAll('.flits_wishlist_page_table_cell_price *, .flits_wishlist_page_grid_item [class*="price"]'), function (el) {
      if (el.children.length) { return; }
      var t = el.textContent.replace(/(\d+\.\d{2})(?!\d)/, function (x) { return parseFloat(x).toFixed(3); });
      if (t !== el.textContent) { el.textContent = t; }
    });
  }

  function textRect(el) { var r = document.createRange(); r.selectNodeContents(el); return r.getBoundingClientRect(); }
  function shift(el, dx) { el.style.transform = Math.abs(dx) < 0.5 ? '' : 'translateX(' + dx.toFixed(1) + 'px)'; }
  function whiteCard(row) {
    var e = row.parentElement;
    while (e && e !== document.body) { if (getComputedStyle(e).backgroundColor === 'rgb(255, 255, 255)') { return e; } e = e.parentElement; }
    return null;
  }
  var VSEL = '.flits_wishlist_page_table_cell_variant select, .flits_wishlist_page_table_cell_variant .flits_wishlist_page_variant_static';
  function layout() {
    var rows = document.querySelectorAll('.flits_wishlist_page_table_row');
    if (!rows.length) { return; }
    var r0 = rows[0];
    var hp = document.querySelector('.flits_wishlist_page_table_header_cell_price'),
        hn = document.querySelector('.flits_wishlist_page_table_header_cell_product'),
        hv = document.querySelector('.flits_wishlist_page_table_header_cell_variant'),
        hq = document.querySelector('.flits_wishlist_page_table_header_cell_quantity');
    [hp, hn, hv, hq].forEach(function (h) { if (h) { h.style.transform = ''; } });
    Array.prototype.forEach.call(rows, function (r) { var p = r.querySelector('.flits_wishlist_page_table_cell_price'); if (p) { p.style.transform = ''; } });
    if (RTL) {
      var img = r0.querySelector('.flits_wishlist_page_table_cell_image'), card = whiteCard(r0), rr = r0.getBoundingClientRect();
      if (img) {
        var cr = card ? card.getBoundingClientRect() : rr;
        var gap = (cr.right - img.getBoundingClientRect().right) - (rr.left - cr.left);
        document.documentElement.style.setProperty('--layla-wl-gap', Math.max(0, gap).toFixed(1) + 'px');
      }
    }
    /* price value: centred between the variant select and the quantity box */
    var done = false;
    Array.prototype.forEach.call(rows, function (r) {
      var v = r.querySelector(VSEL), q = r.querySelector('.flits_wishlist_page_quantity_selector'), p = r.querySelector('.flits_wishlist_page_table_cell_price');
      if (!v || !q || !p) { return; }
      var a = v.getBoundingClientRect(), b = q.getBoundingClientRect(), lo, hi;
      if (a.left > b.left) { lo = b.right; hi = a.left; } else { lo = a.right; hi = b.left; }
      var t = textRect(p);
      if (t.width) { shift(p, (lo + hi) / 2 - (t.left + t.right) / 2); done = true; }
    });
    /* headers: same edge as their values (right in Arabic, left in English) */
    var p0 = r0.querySelector('.flits_wishlist_page_table_cell_price');
    if (hp && p0 && done) { var pt = textRect(p0), ht = textRect(hp); if (ht.width && pt.width) { shift(hp, RTL ? pt.right - ht.right : pt.left - ht.left); } }
    if (RTL) {
      var n0 = r0.querySelector('.flits_wishlist_page_table_cell_info'), v0 = r0.querySelector(VSEL), q0 = r0.querySelector('.flits_wishlist_page_quantity_selector');
      if (hn && n0) { var t0 = textRect(hn); if (t0.width) { shift(hn, n0.getBoundingClientRect().right - t0.right); } }
      if (hv && v0) { var t1 = textRect(hv); if (t1.width) { shift(hv, v0.getBoundingClientRect().right - t1.right); } }
      if (hq && q0) { var t2 = textRect(hq); if (t2.width) { shift(hq, q0.getBoundingClientRect().right - t2.right); } }
    }
  }
  var lt = null;
  function layoutSoon() { clearTimeout(lt); lt = setTimeout(layout, 60); }
  window.addEventListener('resize', layoutSoon);
  window.addEventListener('load', layoutSoon);

  function go() {
    fixWishlist();
    var q = false;
    new MutationObserver(function () { if (q) { return; } q = true; setTimeout(function () { q = false; fixWishlist(); }, 150); }).observe(document.body, { childList: true, subtree: true });
  }
  if (!/flits-wishlist/.test(location.pathname)) { return; }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', go); } else { go(); }
})();
